<template>
  <div class="patentList fatherHeight contBox">
    <div class="flex-between" style="margin-top: 15px;">
      <div class="search-top ">
        <el-form :inline="true" :model="searchData" ref="searchForm" class="demo-form-inline" :label-width="120"
          label-suffix=":">
          <el-form-item label="对账时间">
            <el-date-picker format="YYYY-MM-DD" value-format="YYYY-MM-DD" v-model="searchData.time" type="daterange"
              range-separator="-" placeholder="请选择" clearable></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="searchBut">
        <el-button class="color-main" @click="resetForm" type="primary">
          <i class="fa fa-refresh"></i>重置
        </el-button>
        <el-button @click="handleSearch" class="color-main" type="primary">
          <i class="fa fa-search"></i>查询
        </el-button>
        <el-button class="color-vice" type="primary" @click="reconciliat">
          对账
        </el-button>
      </div>
    </div>
    <div class="patientList" ref="tableBoxRef">
    <div class="table" >
      <el-table v-loading="dataListLoading" :data="tableData" class="table-ellipsis" v-if="istable" size="small" border
        :max-height="tableHei">
        <el-table-column fixed  prop="start_time" label="开始时间"  />
        <el-table-column  prop="end_time"  label="结束时间" align="center" />
        <el-table-column  prop="status"  label="对账状态" align="center" />
        <el-table-column  prop="insutype_name" align="center" label="险种类型" />
        <el-table-column prop="medfee_sumamt"  align="center" label="医疗费总额" />
        <el-table-column prop="fund_pay_sumamt"  align="center" label="基金支付总额" />
        <el-table-column  prop="acct_pay"  label="个人账户支出" align="center" />
        <el-table-column  prop="fixmedins_setl_cnt"  label="结算笔数" align="center" />
      </el-table>
      <div class="pagination-box">
        <el-pagination :currentPage="pageData.currentPage" :page-size="pageData.pageSize"
          :page-sizes="[10, 20, 50, 100]" :background="true" layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.totalSum" @size-change="handleSizeChange"
          @current-change="handleCurrentChange"></el-pagination>
      </div>
    </div>
  </div>
  <reconciliatInfo v-if="isViewDialog" ref="reconciliatInfoRef" @reconciliate="handleSearch"></reconciliatInfo>
  </div>
</template>
<script>
  import {
    reactive,
    toRefs,
    ref,
    nextTick,
    onMounted,
    onBeforeUnmount, getCurrentInstance
  } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import service from '@/utils/request'
  import searchBox from '@/components/search/searchBox.vue'
  import { gitDictList, gitDictVal, TimestampToTime } from '@/utils/tool'
  import { ElMessageBox, ElMessage, ElNotification } from 'element-plus'
  import reconciliatInfo from './reconciliatInfo'
  import { runInNewContext } from 'vm'
  export default {
    name: 'patentList',
    components: {
      reconciliatInfo
    },
    setup() {
      let { proxy } = getCurrentInstance()
      const isViewDialog = ref(false)
      const state = reactive({
        searchData: {
          start_time: '',//挂号开始
          end_time: '',//挂号结束
          time: '',
        },
        formData: {},
        pageData: {
          currentPage: 1,
          pageSize: 10,
          totalSum: 0,
        },
        dataListLoading: false,
        tableData: [],
        searchForm: null,
        istable: true,
        tableBoxRef: null,
        tableHei: 0,
      })

      onMounted(() => {
        state.searchData.time = [TimestampToTime(), TimestampToTime()]
        state.istable = false
        state.tableHei = state.tableBoxRef.clientHeight - 40
        nextTick(() => {
          state.istable = true
        })
        handleSearch()
      })

      const handleSizeChange = (val) => {
        state.pageData.pageSize = val
        getDataList()
      }

      const handleCurrentChange = (val) => {
        state.pageData.currentPage = val
        getDataList()
      }

      const resetForm = () => {
        Object.keys(state.searchData).forEach((key) => (state.searchData[key] = ""))
        state.searchData.time = [TimestampToTime(), TimestampToTime()]
        handleSearch()
      }

      const handleSearch = () => {
        state.pageData.currentPage = 1
          getDataList()
      }

      const getDataList = async () => {
        state.dataListLoading = true
        let data = {}
        if (state.searchData.time) {
          data = {
            start_time: state.searchData.time[0],
            end_time: state.searchData.time[1],
            current: state.pageData.currentPage,
            size: state.pageData.pageSize,
          }
        } else {
          data = {
            current: state.pageData.currentPage,
            size: state.pageData.pageSize,
          }
        }
        let res = await service.post(
          '/api/settle/getStmtList',
          data
        )
        state.dataListLoading = false
        if (res.code === 0) {
          if (res.data.total > 0) {
            state.tableData = res.data.list
            state.pageData.totalSum = res.data.total
          } else {
            state.tableData = []
            state.pageData.totalSum = 0
          }
        }
      }
      //对账
      const reconciliat = ()=> {
         isViewDialog.value = true
         nextTick(()=>{
          proxy.$refs.reconciliatInfoRef.visible = true
         proxy.$refs.reconciliatInfoRef.getDataList()
         })
      }
     
      return {
        ...toRefs(state),
        handleSizeChange,
        handleCurrentChange,
        handleSearch,
        getDataList,
        resetForm,
        reconciliat,
        isViewDialog
      }
    },
  }
</script>
<style lang="scss">
  .el-notification__group {
    flex: 1;
  }

  .notice_but {
    text-align: right;
    color: #3167a8;
    cursor: pointer;
  }
</style>
<style scoped lang="scss">
 
  .table-tag {
    margin-right: 8px;
  }

  .fa-stack {
    width: 24px;
    height: 24px;
    cursor: pointer;
    float: right;

    .fa-stack-2x {
      font-size: 24px;
      color: rgba(49, 102, 174, 0.1);
    }

    .fa-stack-1x {
      font-size: 12px;
      color: #3166ae;
      line-height: 24px;
    }
  }

  .tagBox {
    display: flex;
    justify-content: flex-start;

    // margin-bottom: 10px;
    .tit {
      width: 83px;
      font-size: 14px;
      font-family: 'Source Han Sans CN-Bold';
      font-weight: bold;
      color: #666666;
    }

    .cont {
      width: calc(100% - 83px);
    }
  }

  .patientList {
    margin-top: 4px;
    height: calc(100% - 80px);
  }

  .list-top {
    .name {
      font-size: 18px;
      font-family: ' Source Han Sans CN-Medium';
      font-weight: 500;
      color: #000000;
      line-height: 32px;
    }
  }

  .patient-alert {
    background: rgba(49, 102, 174, 0.1);
    border-radius: 4px 4px 4px 4px;
    font-size: 18px;
    color: #3166ae;
    margin-top: 8px;
    padding: 4px 16px;

    .el-alert__icon {
      color: #3166ae;
    }

    &:deep(.el-alert__content) {
      position: relative;
      top: 3px;
    }
  }

  /* .table {
    margin-top: 10px;
    height: calc(100% - 82px);

    .img {
      width: 25px;
      height: 24px;
      margin-right: 14px;
    }
  } */

  .searchBut {
    width: 100%;
    //margin-left: 20px;
    //margin-right: 29px;
    justify-self: right;
    display: flex;
    justify-content: end;
    margin-right: 28px;
  }

  .del {
    background-color: #ffecec;
    color: #ff6b6b;
    font-weight: 700;
  }

  .modify {
    background-color: #3166ae;
  }

  .bar-title {
    font-size: 18px;
    line-height: 18px;
    color: #000000;
    border-left: 6px solid #3166ae;
    padding: 0 18px;
    margin-bottom: 16px;
    font-weight: bold;
  }
</style>